<template>
  <div class="content-wrapper">
    <section class="content-header">
      <div class="container-fluid">
        <div class="row mb-2">
          <div class="col-sm-6">
            <h1>
              <router-link class="btn btn-sm" :to="{ name: 'NextHopGroupList' }"
                ><i class="fas fa-chevron-left"></i>
              </router-link>
              Next Hop Group
            </h1>
          </div>
          <div class="col-sm-6">
            <ol class="breadcrumb float-sm-right">
              <li class="breadcrumb-item">
                <router-link :to="{ name: 'Home' }">Home</router-link>
              </li>
              <li class="breadcrumb-item active">Next Hop Group</li>
            </ol>
          </div>
        </div>
      </div>
    </section>

    <section class="content">
      <div class="container-fluid">
        <div class="card" id="NextHopGroup">
          <div class="overlay" v-if="is_loading">
            <img src="/assets/images/loader.svg" alt="" />
          </div>
          <form @submit.prevent="handleSubmission()" method="POST" novalidate>
            <div class="card-header">
              <h3 class="card-title" v-if="!is_edit">Create</h3>
              <h3 class="card-title" v-if="is_edit">Edit</h3>
            </div>
            <div class="card-body">
              <div class="row">
                <div class="col-md-8">
                  <div v-if="organizationId == 1" class="form-group required">
                    <label class="control-label">Audra</label>
                    <input
                      v-if="is_edit"
                      v-model="pre.audraName[value.accountId]"
                      id="accountId"
                      name="accountId"
                      class="form-control accountId"
                      readonly
                    />
                    <multiselect
                      v-else
                      v-model="value.accountId"
                      :options="Object.keys(pre.audraName)"
                      :custom-label="opt => pre.audraName[opt]"
                      placeholder="Select Audra Name"
                      :searchable="true"
                      :multiple="false"
                      id="accountId"
                      v-bind:class="{ 'has-error': errors.has('accountId') }"
                      v-validate="'required'"
                      name="accountId"
                    >
                    </multiselect>

                    <div
                      class="help text-danger"
                      v-show="errors.has('accountId')"
                    >
                      {{ errors.first('accountId') }}
                    </div>
                  </div>

                  <div class="form-group required">
                    <label class="control-label">Group Name</label>
                    <input
                      type="text"
                      id="group_name"
                      name="Group Name"
                      v-bind:class="{ 'has-error': errors.has('group_name') }"
                      v-validate="'required'"
                      v-model="value.group_name"
                      class="form-control group_name"
                      placeholder="Group Name"
                    />
                    <div
                      class="help text-danger"
                      v-show="errors.has('Group Name')"
                    >
                      {{ errors.first('Group Name') }}
                    </div>
                  </div>

                  <h4
                    class="card-common-title p-0 mb-2"
                    :class="{
                      'pb-2 border-bottom': !ipAdresses.length > 0
                    }"
                  >
                    Ip Address
                  </h4>

                  <div class="w-full mt-3 p-10">
                    <div v-for="(ipAddress, index) in ipAdresses" :key="index">
                      <div class="flex justify-start ml-2 mt-4">
                        <label class="control-label">IP Address</label>
                        <input
                          type="text"
                          :id="'ip_' + index"
                          :name="'ip_' + index"
                          v-bind:class="{
                            'has-error': errors.has('ip_' + index)
                          }"
                          v-model="ipAddress.ip"
                          class="form-control ip"
                          placeholder="IP Address"
                          :keyup="setIPError(index, ipAddress.ip)"
                        />
                        <div class="help text-danger">
                          {{ ipErrors[index] }}
                        </div>
                      </div>
                      <div
                        class="d-flex justify-content-end border-bottom pb-3 mb-3"
                      >
                        <a class="text-danger fw-500" @click="remove(index)">
                          <i class="icon-trash"></i> Remove
                        </a>
                      </div>
                    </div>

                    <div class="form-group text-right">
                      <a @click.prevent="addMore()" class="pc fw-500">
                        <i class="fas fa-plus-circle"></i> New
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="card-footer pt-0 pb-4">
              <button type="submit" v-if="!is_edit" class="btn">Submit</button>
              <button type="submit" v-if="is_edit" class="btn">Update</button>
            </div>
          </form>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
//import MasterLayout from "@/components/layouts/MasterLayoutComponent";
import LocalStorage from '@/services/localStorage'
import { DepartmentsAPI, CommonAPI } from '@/services/api'
import axios from 'axios'

export default {
  name: 'NextHopGroupForm',
  metaInfo: {
    title: 'Next Hop Group | Dotlines'
  },
  components: {},
  data: () => ({
    organizationId: LocalStorage.get('organizationId'),
    userEmail: LocalStorage.get('userEmail'),
    isSelectorLoading: false,
    is_loading: false,
    is_edit: false,
    params: {},

    value: {},
    pre: {
      audraName: []
    },
    ipAdresses: [],
    ipErrors: []
  }),
  methods: {
    handleSubmission () {
      const _this = this
      // this.setCustomValidation()
      this.$validator.validateAll().then(result => {
        this.integrateIPAddresses()
        if (result && _this.validateAllIp()) {
          _this.is_loading = true
          let api_url = '/next_hop_groups'
          let method = 'POST'
          if (_this.is_edit) {
            api_url = '/next_hop_groups/' + _this.$route.params.id
            method = 'PUT'
          }

          axios({
            method: method,
            url: api_url,
            data: _this.value,
            headers: { 'Content-Type': 'application/json' }
          })
            .then(function (response) {
              _this.$toaster.success(response.data.message)
              _this.$router.push({ name: 'NextHopGroupList' })
            })
            .catch(errors => {
              if (errors.response.status === 501) {
                _this.$toaster.error(errors.response.data.errors.message)
                _this.$setErrorsFromResponse(errors.response.data.errors)
              } else if (errors.response.data) {
                _this.$toaster.error(errors.response.data.message)
                _this.$setErrorsFromResponse(errors.response.data)
              }
            })
            .finally(() => {
              _this.is_loading = false
            })
        }
      })
    },
    getDetail: function (id) {
      return new Promise((resolve, reject) => {
        const api_url = '/next_hop_groups/' + id
        axios
          .get(api_url, {
            params: { accountId: LocalStorage.get('accountId') }
          })
          .then(response => {
            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
      })
    },
    async initialize () {
      this.is_loading = true
      this.params = this.$route.params

      if (!_.isEmpty(this.params) && this.params.id !== undefined) {
        this.is_edit = true
      }
      if (this.is_edit) {
        await this.getDetail(this.params.id)
          .then(response => {
            this.value = response.data
            this.makeIpAddressArray()
          })
          .catch(errors => {
            if (errors.response.status === 501) {
              this.$toaster.error(errors.response.data.errors.message);
              this.$setErrorsFromResponse(errors.response.data.errors);
            } else if (errors.response.data) {
              this.$toaster.error(errors.response.data.message);
              this.$setErrorsFromResponse(errors.response.data);
            }
            this.$router.back()
          })
      } else {
        this.value.accountId = LocalStorage.get('accountId')
      }

      await CommonAPI.getAudraName(LocalStorage.get('accountId')).then(
        response => {
          this.pre.audraName = response
        }
      )

      this.is_loading = false
    },
    addMore () {
      this.ipAdresses.push({
        ip: ''
      })

      this.ipErrors.push('')
    },
    remove (index) {
      this.ipAdresses.splice(index, 1)
      this.ipErrors.splice(index, 1)
      // this.ipErrors['ip_' + index] = ''
      this.$validator.validateAll()
    },
    integrateIPAddresses () {
      if (this.ipAdresses.length) this.value.ip = this.ipAdresses[0].ip
      for (let i = 1; i < this.ipAdresses.length; i++) {
        this.value.ip += ', ' + this.ipAdresses[i].ip
      }
    },
    makeIpAddressArray () {
      const ipAddress = this.value.ip.split(', ')
      if (ipAddress.length) {
        this.ipAdresses = []
      }
      for (let i = 0; i < ipAddress.length; i++) {
        this.ipAdresses.push({ ip: ipAddress[i] })
      }
    },
    setIPError (index, ip) {
      if (!ip) {
        // this.ipErrors['ip_' + index] = 'This field is required!'
        this.ipErrors[index] = 'This field is required!'
      } else if (!this.validateIp(ip)) {
        // this.ipErrors['ip_' + index] = 'The input format is invalid. Valid Format : 192.168.20.0'
        this.ipErrors[index] =
          'The input format is invalid. Valid Format : 192.168.20.0'
      } else {
        // this.ipErrors['ip_' + index] = ''
        this.ipErrors[index] = ''
      }
    },
    validateIp (ip) {
      if (
        /^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/.test(
          ip
        )
      ) {
        return true
      }
      return false
    },
    validateAllIp () {
      // const keys = Object.keys(this.ipErrors)
      // console.log(this.ipErrors)
      // console.log(keys)
      // for (let i = 0; i < keys.length; i++) {
      //   if (this.ipErrors[keys[i]] != '') return false
      // }
      for (let i = 0; i < this.ipErrors.length; i++) {
        if (this.ipErrors[i] != '') return false
      }
      return true
    }
  },
  mounted () {
    this.initialize()
  }
}
</script>
